import { useMutation, useQueryClient } from '@tanstack/react-query';
import { favoriteMarketService, type MarketDetail } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';
import { bridge } from 'shared/src/utils';

export const useDeleteFavoriteMarket = (marketId: number) => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return favoriteMarketService
        .delete({ sno: marketId })
        .then(res => res.data);
    },
    onSuccess: () => {
      bridge.favoriteMarket({ market_sno: marketId, is_favorite: false });
      client.setQueryData<MarketDetail>(
        queryKey.marketDetail(marketId),
        oldData => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            market: {
              ...oldData.market,
              favorite: null,
            },
          };
        },
      );
    },
  });
};
